module.exports = __webpack_public_path__ + "static/media/isophya_modestior_003_APA.7f5e2f21.png";